/* eslint-disable */
import React, { useEffect, useContext, useState } from "react";
import { Link, useParams, useHistory } from "react-router-dom";
import Select from "react-select";
import { useTranslation } from "react-i18next";

import * as url from "helper/UrlHelper";
import { deleteData, getData, postData, putData } from "utils/Gateway";
import { getCurrentDateInString } from "helper/getcurrentdatestring";
import { reactSelectStyle } from "Config/Config";

const SaveNotePopup = ({
  selectedNoteId = null,
  setSelectedNoteId = () => {},
  afterPopupClose = () => {},
  setShowAlert,
  setAlertMessage,
  setMessageType,
}) => {
  const token = localStorage.getItem("token");
  const { t } = useTranslation();

  const [noteLeadId, setNoteLeadId] = useState(null);
  const [noteContactId, setNoteContactId] = useState(null);
  const [noteOpportunityId, setNoteOpportunityId] = useState(null);
  const [noteTaskId, setNoteTaskId] = useState(null);
  const [noteInvoiceId, setnoteInvoiceId] = useState(null);
  const [noteInvoiceDocId, setNoteInvoiceDocId] = useState(null);

  const [noteModuleName, setNoteModuleName] = useState("");
  const [noteComponentName, setNoteComponentName] = useState("");
  const [existingNoteTitle, setExistingNoteTitle] = useState("");
  const [existingNoteDetails, setExistingNoteDetails] = useState("");
  const [existingNoteDate, setExistingNoteDate] = useState("");
  const [existingNotePrivate, setExistingNotePrivate] = useState(false);

  const [title, settitle] = useState("");
  const [description, setdescription] = useState("");
  const [isPrivate, setIsPrivate] = useState(false);
  const [updateExistingNote, setUpdateExistingNote] = useState(false);
  const [isSaving, setIsSaving] = useState(false);

  // Validation state from AddNewNotePopup
  const [errors, setErrors] = useState({});

  // Validation function from AddNewNotePopup
  const validateForm = () => {
    const newErrors = {};

    if (!noteModuleName) {
      newErrors.module = t("Please select a module for the note.");
    }
    if (!noteComponentName) {
      newErrors.moduleId = t("Please select a component for the note.");
    }
    if (!title.trim()) {
      newErrors.title = t(
        "Note title is required. Please enter a descriptive title."
      );
    }
    if (!description.trim()) {
      newErrors.details = t(
        "Note description is required. Please provide details."
      );
    }

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const getNoteDetails = async () => {
    if (!selectedNoteId) return;
    try {
      let requestUrl = `${url.API_BASE_URL}${url.API_GET_NOTE_DETAILS}/${selectedNoteId}?token=${token}`;
      const response = await getData(requestUrl);
      if (response.status) {
        const { data } = response;
        setNoteLeadId(data.leadid);
        setNoteContactId(data.contactid);
        setNoteTaskId(data.taskid);
        if (data.notemodulename === "opportunity") {
          setNoteOpportunityId(data.invoiceid);
        } else if (data.notemodulename === "invoice") {
          setnoteInvoiceId(data.invoiceid);
        }
        setNoteInvoiceDocId(data.invoicedocid);
        setNoteModuleName(data.notemodulename);
        setNoteComponentName(data.notecomponent);
        setExistingNoteTitle(data.title);
        setExistingNoteDetails(data.details);
        setExistingNoteDate(data.notedate);
        setExistingNotePrivate(data.isprivate);
      }
    } catch (error) {
      setAlertMessage(error.message);
      setMessageType("error");
      setShowAlert(true);
    }
  };

  const updateNoteStatus = () => {
    setUpdateExistingNote(true);
    settitle(existingNoteTitle);
    setdescription(existingNoteDetails);
    setIsPrivate(existingNotePrivate);
  };

  const clearNoteStatus = () => {
    setUpdateExistingNote(false);
    settitle("");
    setdescription("");
    setIsPrivate(false);
  };

  const saveNote = async () => {
    if (!validateForm()) {
      return;
    }
    try {
      setIsSaving(true);
      let noteData = {
        notetype: "1",
        title,
        details: description,
        isprivate: isPrivate,
      };

      if (noteLeadId) noteData.leadid = noteLeadId;
      if (noteContactId) noteData.contactid = noteContactId;
      if (noteOpportunityId) noteData.invoiceid = noteOpportunityId;
      if (noteTaskId) noteData.taskid = noteTaskId;
      if (noteInvoiceId) noteData.invoiceid = noteInvoiceId;
      if (noteInvoiceDocId) noteData.invoicedocid = noteInvoiceDocId;

      let requestUrl = url.API_BASE_URL;
      let response = {};

      if (updateExistingNote) {
        requestUrl += `${url.API_UPDATE_NOTE}/${selectedNoteId}?token=${token}`;
        response = await putData(requestUrl, noteData);
      } else {
        requestUrl += `${url.API_ADD_NEW_NOTE}?token=${token}`;
        response = await postData(requestUrl, noteData);
      }

      setIsSaving(false);
      if (response.status) {
        setMessageType("success");
        bootstrap.Offcanvas.getInstance(
          document.querySelector("#saveNote")
        ).hide();
        resetHandler();
        afterPopupClose();
      } else {
        setMessageType("error");
      }
      setAlertMessage(response.message);
    } catch (error) {
      setAlertMessage(error.message);
      setMessageType("error");
    }
    setShowAlert(true);
  };

  const resetHandler = () => {
    setErrors({});
    setNoteLeadId(null);
    setNoteContactId(null);
    setNoteOpportunityId(null);
    setNoteTaskId(null);
    setnoteInvoiceId(null);
    settitle("");
    setdescription("");
    setIsPrivate(false);
    setNoteModuleName("");
    setNoteComponentName("");
    setExistingNoteTitle("");
    setExistingNoteDetails("");
    setExistingNotePrivate(false);
    setUpdateExistingNote(false);
    setSelectedNoteId(null);
  };

  useEffect(() => {
    if (selectedNoteId) {
      getNoteDetails();
    }
  }, [selectedNoteId]);

  return (
    <div
      className="offcanvas invoice_w offcanvas-end bg-white border-0"
      tabIndex="-1"
      id="saveNote"
      aria-labelledby="saveNote"
    >
      <div className="offcanvas-header bg-primary text-white p-4 pe-5 pb-3 border-bottom border-gray-300">
        <div className="d-flex align-items-center gap-3">
          <div className="icon-wrapper p-3 bg-white rounded-circle d-flex align-items-center justify-content-center">
            <span className="material-symbols-outlined text-primary fs-5 icon-md">
              description
            </span>{" "}
          </div>
          <div>
            <h3
              className="offcanvas-title fw-bold text-white mb-0"
              id="offcanvasLabelDetailsLabel"
            >
              {t("Save Note")}
            </h3>
            <p className="text-white fs-sm mb-0">
              {t("Manage and save your notes")}
            </p>
          </div>
        </div>
        <button
          type="button"
          className="btn-close p-1 bg-gray-200 rounded-circle shadow-sm border-0"
          data-bs-dismiss="offcanvas"
          aria-label="Close"
          onClick={resetHandler}
        ></button>
      </div>
      <div className="offcanvas-body p-4">
        <div className="row">
          <div className="col-lg-8">
            <div className="p-3 p-md-4 border border-gray-300 rounded-10 shadow-sm">
              <form
                onSubmit={(e) => e.preventDefault()}
                className="d-flex flex-column h-100"
              >
                <div className="fields-container flex-fill">
                  <div className="form-group mb-4 p-3 border rounded-8 shadow-sm bg-white">
                    <label
                      htmlFor="module"
                      className="d-block fs-sm fw-semibold mb-2 text-dark"
                    >
                      {t("Module")}
                    </label>
                    <p
                      id="module"
                      className={`form-control fs-sm shadow-none ${
                        errors.module ? "is-invalid" : "border border-gray-300"
                      }`}
                    >
                      {noteModuleName || t("N/A")}
                    </p>
                    {errors.module && (
                      <div className="invalid-feedback d-block">
                        {errors.module}
                      </div>
                    )}
                  </div>
                  <div className="form-group mb-4 p-3 border rounded-8 shadow-sm bg-white">
                    <label
                      htmlFor="component"
                      className="d-block fs-sm fw-semibold mb-2 text-dark"
                    >
                      {t("Component")}
                    </label>
                    <p
                      id="component"
                      className={`form-control fs-sm shadow-none ${
                        errors.moduleId
                          ? "is-invalid"
                          : "border border-gray-300"
                      }`}
                    >
                      {noteComponentName || t("N/A")}
                    </p>
                    {errors.moduleId && (
                      <div className="invalid-feedback d-block">
                        {errors.moduleId}
                      </div>
                    )}
                  </div>

                  <div className="form-group mb-4 p-3 border rounded-8 shadow-sm bg-white">
                    <label
                      htmlFor="title"
                      className="d-block fs-sm fw-semibold mb-2 text-dark"
                    >
                      {t("Title")} <span className="text-danger">*</span>
                    </label>
                    <input
                      type="text"
                      id="title"
                      className={`form-control fs-sm shadow-none ${
                        errors.title ? "is-invalid" : "border border-gray-300"
                      }`}
                      placeholder={t("e.g., Meeting Notes, Follow-up Action")}
                      value={title}
                      onChange={(e) => {
                        settitle(e.target.value);
                        if (errors.title)
                          setErrors((prev) => ({ ...prev, title: "" }));
                      }}
                    />
                    {errors.title && (
                      <div className="invalid-feedback">{errors.title}</div>
                    )}
                  </div>

                  <div className="form-group mb-4 p-3 border rounded-8 shadow-sm bg-white">
                    <label
                      htmlFor="description"
                      className="d-block fs-sm fw-semibold mb-2 text-dark"
                    >
                      {t("Description")} <span className="text-danger">*</span>
                    </label>
                    <textarea
                      id="description"
                      rows="5"
                      className={`form-control fs-sm shadow-none ${
                        errors.details ? "is-invalid" : "border border-gray-300"
                      }`}
                      placeholder={t(
                        "Provide a detailed description of the note content."
                      )}
                      value={description}
                      onChange={(e) => {
                        setdescription(e.target.value);
                        if (errors.details)
                          setErrors((prev) => ({ ...prev, details: "" }));
                      }}
                    ></textarea>
                    {errors.details && (
                      <div className="invalid-feedback">{errors.details}</div>
                    )}
                  </div>

                  <div className="form-group mb-4 p-3 border rounded-8 shadow-sm bg-white">
                    <div className="form-check d-flex align-items-center gap-2 fs-sm p-0 m-0">
                      <input
                        className="form-check-input bg-transparent border-2 border-gray-600 shadow-none m-0"
                        type="checkbox"
                        id="isPrivate"
                        checked={isPrivate}
                        onChange={(e) => setIsPrivate(e.target.checked)}
                      />
                      <label
                        className="form-check-label fw-semibold text-dark"
                        htmlFor="isPrivate"
                      >
                        {t("Mark as Private")}
                      </label>
                    </div>
                  </div>
                </div>

                <div className="action d-flex justify-content-end pt-4 border-top mt-auto">
                  <button
                    onClick={saveNote}
                    type="button"
                    className="btn btn-primary d-flex align-items-center gap-2"
                    disabled={isSaving}
                    style={{
                      cursor: isSaving ? "not-allowed" : "pointer",
                    }}
                  >
                    {isSaving ? (
                      <>
                        <span
                          className="spinner-border spinner-border-sm"
                          role="status"
                          aria-hidden="true"
                        ></span>
                        {t("Saving...")}
                      </>
                    ) : (
                      <>
                        <span className="material-symbols-outlined me-1">
                          save
                        </span>{" "}
                        {t("Save Note")}
                      </>
                    )}
                  </button>
                </div>
              </form>
            </div>
          </div>
          <div className="col-lg-4">
            <div className="p-4 border border-gray-300 rounded-10 shadow-sm">
              <div className="d-flex align-items-center gap-2 mb-3">
                <span className="material-symbols-outlined fs-md text-primary">
                  format_list_bulleted
                </span>
                <h5 className="fw-bold mb-0 text-dark">{t("Existing Note")}</h5>
              </div>

              <div className="notes-container">
                {existingNoteTitle && (
                  <div
                    className="note-card bg-white border border-gray-300 rounded-15 p-4 mb-3 shadow-sm position-relative overflow-hidden"
                    style={{
                      transition: "all 0.3s ease-in-out",
                    }}
                    onMouseEnter={(e) => {
                      e.currentTarget.style.transform = "translateY(-2px)";
                      e.currentTarget.style.boxShadow =
                        "0 8px 25px rgba(0, 0, 0, 0.1)";
                    }}
                    onMouseLeave={(e) => {
                      e.currentTarget.style.transform = "translateY(0)";
                      e.currentTarget.style.boxShadow =
                        "0 1px 6px rgba(62, 96, 147, 0.18)";
                    }}
                  >
                    {/* Note Header */}
                    <div className="d-flex align-items-start justify-content-between mb-3">
                      <div className="flex-fill">
                        <div className="d-flex align-items-center gap-2 mb-2">
                          <div
                            className="p-2 bg-primary text-white rounded-circle d-flex align-items-center justify-content-center"
                            style={{ width: "30px", height: "30px" }}
                          >
                            <span className="material-symbols-outlined fs-sm">
                              {existingNotePrivate ? "lock" : "note"}
                            </span>
                          </div>
                          <h6 className="fw-bold mb-0 text-dark">
                            {existingNoteTitle}
                          </h6>
                          {existingNotePrivate && (
                            <span className="badge bg-warning-subtle text-warning fs-xs px-2 py-1 rounded-pill">
                              {t("Private")}
                            </span>
                          )}
                        </div>
                      </div>

                      <div className="dropdown">
                        <button
                          className="btn btn-outline-secondary btn-sm rounded-circle d-flex align-items-center justify-content-center dropdown-toggle border-0"
                          type="button"
                          data-bs-toggle="dropdown"
                          aria-expanded="false"
                          style={{
                            width: "32px",
                            height: "32px",
                            transition: "all 0.3s ease-in-out",
                          }}
                          onMouseEnter={(e) => {
                            e.currentTarget.style.backgroundColor =
                              "var(--bs-secondary)";
                            e.currentTarget.style.color = "white";
                          }}
                          onMouseLeave={(e) => {
                            e.currentTarget.style.backgroundColor =
                              "transparent";
                            e.currentTarget.style.color = "var(--bs-secondary)";
                          }}
                        >
                          <span className="material-symbols-outlined fs-sm">
                            more_vert
                          </span>
                        </button>

                        <ul
                          className="dropdown-menu dropdown-menu-end border-0 rounded-10 shadow-lg p-2"
                          style={{ minWidth: "160px" }}
                        >
                          <li>
                            <Link
                              className="dropdown-item d-flex align-items-center gap-3 py-2 px-3 rounded-8 text-decoration-none"
                              to="#"
                              onClick={updateNoteStatus}
                              style={{
                                transition: "all 0.3s ease-in-out",
                              }}
                              onMouseEnter={(e) => {
                                e.currentTarget.style.backgroundColor =
                                  "rgba(238, 82, 60, 0.1)";
                                e.currentTarget.style.transform =
                                  "translateX(5px)";
                              }}
                              onMouseLeave={(e) => {
                                e.currentTarget.style.backgroundColor =
                                  "transparent";
                                e.currentTarget.style.transform =
                                  "translateX(0)";
                              }}
                            >
                              <span className="material-symbols-outlined fs-sm text-primary">
                                edit
                              </span>
                              <span className="fw-semibold">
                                {t("Edit Note")}
                              </span>
                            </Link>
                          </li>
                          <li>
                            <Link
                              className="dropdown-item d-flex align-items-center gap-3 py-2 px-3 rounded-8 text-decoration-none"
                              to="#"
                              onClick={clearNoteStatus}
                              style={{
                                transition: "all 0.3s ease-in-out",
                              }}
                              onMouseEnter={(e) => {
                                e.currentTarget.style.backgroundColor =
                                  "rgba(220, 53, 69, 0.1)";
                                e.currentTarget.style.transform =
                                  "translateX(5px)";
                              }}
                              onMouseLeave={(e) => {
                                e.currentTarget.style.backgroundColor =
                                  "transparent";
                                e.currentTarget.style.transform =
                                  "translateX(0)";
                              }}
                            >
                              <span className="material-symbols-outlined fs-sm text-danger">
                                delete
                              </span>
                              <span className="fw-semibold text-danger">
                                {t("Clear Note")}
                              </span>
                            </Link>
                          </li>
                        </ul>
                      </div>
                    </div>

                    {/* Note Content */}
                    <div className="note-content">
                      <div className="d-flex align-items-center gap-2 mb-2">
                        <span className="material-symbols-outlined fs-sm text-muted">
                          schedule
                        </span>
                        <small className="text-muted fw-semibold">
                          {existingNoteDate}
                        </small>
                      </div>
                      {existingNoteDetails && (
                        <div className="d-flex align-items-start gap-2 mb-2">
                          <span className="material-symbols-outlined fs-sm text-muted">
                            description
                          </span>
                          <p
                            className="text-dark mb-0 lh-base"
                            style={{ fontSize: "0.95rem" }}
                          >
                            {existingNoteDetails}
                          </p>
                        </div>
                      )}
                    </div>
                  </div>
                )}
                {!existingNoteTitle && (
                  <div className="text-center py-5">
                    <div
                      className="p-4 bg-light rounded-circle d-inline-flex align-items-center justify-content-center mb-3"
                      style={{ width: "80px", height: "80px" }}
                    >
                      <span
                        className="material-symbols-outlined text-muted"
                        style={{ fontSize: "2rem" }}
                      >
                        note_add
                      </span>
                    </div>
                    <h6 className="fw-bold text-muted mb-2">
                      {t("No Existing Note")}
                    </h6>
                    <p className="text-muted mb-0">
                      {t("Select a note to view its details")}
                    </p>
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SaveNotePopup;
